module.exports = __webpack_public_path__ + "img/pierre-filrouge.7a99a251.png";